export const VOTER_SEARCH_API_LOCATION_CONSTANT = {
  ASSEMBLIES_LIST: "/common/assemblies",
  GAON_LIST: "/common/gaon",
  GAON_LIST_WITH_ASSEMBLY: "/common/gaon/assembly",
  GATNO_LIST: "/common/gatData",
  GAN_NUMBER_LIST: "/common/gan",
  PRABHAG_LIST: "/common/prabhag",
  PRABHAG_AREA_LIST: "/common/prabhagArea",
};
